<template>
  <div>
    <vue-headful
    :title="propsdata[0]['translation']['feedback-head-title']"
    :description="propsdata[0]['translation']['feedback-head-description']"
/>

    <div v-if="loading" style="margin-top: 150px;">
      <lottie-player src="https://qr.io/lottie/qr-loading.json" background="transparent" speed="1" style="width: 230px; height: 230px; margin: 0 auto;" loop autoplay></lottie-player>
    </div>

    <div v-if="!loading" class="pt-5 pt-md-7">
      <div class="container">
        <div class="d-md-flex pt-5 pt-md-0">
          <div class="col-md-4 d-none d-md-block" style="margin-top: 60px;">
            <div class="card border-light p-2">
              <div class="bg-white text-center p-0">
                <div class="profile-thumbnail profile-thumbnail mx-auto">
                  <img :src="feedbacks[0].qr_svg_s3 !== 'needs_update' ? 'https://qr-codes-svg.s3.amazonaws.com/'+qrid+'.svg?'+timenow : 'https://qr.io/qr-svg/'+qrid+'.svg?'+timenow" 
                  class="card-img-top border-white">
                  <p>{{propsdata[0]['translation']['feedback-average-rating']}} <i class="fas fa-star" style="color: rgb(243, 189, 1);"></i> {{feedbacks[0].average}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="mb-3">
              <h2 class="mb-0">{{propsdata[0]['translation']['feedback-title']}}</h2>
            </div>
            <div v-if="error_message != ''" class="alert alert-danger">
              <p>{{error_message}}</p>
            </div>
            <div v-else>
              <div v-if="feedbacks[0].total > 0">
                <div v-if="!pagination_loading" v-for="feedback in feedbacks[0].feedbacks" class="card border-light p-3 mb-3">
                  <div class="d-md-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <div class="rating-star d-sm-inline-block">
                        <i class="fas fa-star" style="color:#f3bd01;"></i> {{feedback.stars}}
                      </div>
                      <p class="mb-0 ml-2">{{feedback.name}}</p>
                    </div>
                    <div><span class="text-muted text-sm">{{feedback.datetime}}</span></div>
                  </div>
                  <p class="text-dark">{{feedback.comment}}</p>
                </div>
                <div v-if="pagination_loading" class="text-center">
                  <img src="/assets/img/global_loader.gif" style="width: 150px;margin: 40px;">
                </div>
                <!-- PAGINATION -->
                <nav v-if="feedbacks[0].total > 1">
                  <ul class="pagination justify-content-center">
                    <li class="page-item" v-if="pagination !== 1">
                      <a @click="paginate(pagination-1)" class="page-link">{{propsdata[0]['translation']['feedback-previous']}}</a>
                    </li>
                    <li v-for="n in feedbacks[0].total" class="page-item" :class='{"active": pagination === n}'>
                      <a v-if="n < pagination+3 && n > pagination-3" @click="paginate(n)" class="page-link">{{n}}</a>
                    </li>
                    <li class="page-item" v-if="pagination !== feedbacks[0].total">
                      <a @click="paginate(pagination+1)" class="page-link">{{propsdata[0]['translation']['feedback-next']}}</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div v-else>
                <div>
                  <h2 class="mb-3">{{propsdata[0]['translation']['feedback-no-feedback']}}</h2>
                  <p>{{propsdata[0]['translation']['feedback-no-feedback-help']}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    props:['propsdata'],
    data() {
      return {
        timenow: Date.now(),
        qrid: '',
        loading: true,
        feedbacks: [],
        error_message: '',
        pagination: 1,
        pagination_loading: false
      };
    },
    methods: {
      paginate(num){
        this.pagination = num;
        this.pagination_loading = true;
        this.error_message = '';
        axios.post('/dashboard/cargar-feedback.php', {
          qrid: this.$route.params.qrid,
          pagination: this.pagination
        })
        .then(response => {
          if(response.data == 'There was an error getting the feedback reviews. Please try again later.'){
            this.error_message = 'There was an error getting the feedback reviews. Please try again later.';
          }
          else{
            this.feedbacks = response.data;
            this.pagination_loading = false;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    mounted() {
      this.qrid = this.$route.params.qrid;
      axios.post('/dashboard/cargar-feedback.php', {
        qrid: this.$route.params.qrid,
        pagination: this.pagination
      })
      .then(response => {
        if(response.data == 'There was an error getting the feedback reviews. Please try again later.'){
          this.error_message = 'There was an error getting the feedback reviews. Please try again later.';
        }
        else if(response.data == 'not his qr code'){
          this.$router.push('/dashboard/');
        }
        else{
          this.loading = false;
          this.feedbacks = response.data;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  };
</script>



// WEBPACK FOOTER //
// src/feedback.vue